const ZimbabweSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112816)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M38.0854 11.4542C37.0693 9.30777 35.6825 7.3716 34.0075 5.72746L19.9997 4.34863L5.99187 5.72754C5.94719 5.77137 5.90359 5.81621 5.85938 5.86051L11.4531 11.4543L19.9997 11.7153L38.0854 11.4542Z"
        fill="#FFDA44"
      />
      <path
        d="M5.85938 34.1416C5.93297 34.2152 6.00641 34.2889 6.08109 34.3614L19.9999 35.6532L33.9186 34.3614C35.6109 32.7207 37.0146 30.7844 38.045 28.6346L12.1737 27.8271C9.94773 30.0532 7.38023 32.6206 5.85938 34.1416Z"
        fill="#FFDA44"
      />
      <path
        d="M39.8009 17.1798L16.5215 16.5215L19.9998 19.9998C18.9695 21.03 17.4316 22.568 16.5215 23.478L39.7887 22.9066C39.927 21.9575 39.9998 20.9872 39.9998 19.9998C39.9998 19.0424 39.931 18.1013 39.8009 17.1798Z"
        fill="black"
      />
      <path
        d="M20.0005 0C14.5452 0 9.60096 2.18516 5.99268 5.72672H34.0083C30.4 2.18516 25.4558 0 20.0005 0Z"
        fill="#6DA544"
      />
      <path
        d="M17.1798 17.1808H39.8009C39.5155 15.159 38.9283 13.2345 38.0855 11.4541H11.4531L17.1798 17.1808Z"
        fill="#D80027"
      />
      <path
        d="M11.3662 28.633H38.045C38.8976 26.8539 39.4942 24.9291 39.7888 22.9062H17.0929C14.8752 25.124 12.9957 27.0035 11.3662 28.633Z"
        fill="#D80027"
      />
      <path
        d="M20.0002 40.0001C25.4108 40.0001 30.3186 37.8507 33.9189 34.3604H6.08154C9.68186 37.8507 14.5897 40.0001 20.0002 40.0001Z"
        fill="#6DA544"
      />
      <path
        d="M7.14141 4.68262C6.6968 5.05621 6.26781 5.44785 5.85742 5.85809L19.9996 20.0003L5.85742 34.1425C6.26773 34.5528 6.6968 34.9443 7.14141 35.3179L22.4591 20.0003L7.14141 4.68262Z"
        fill="black"
      />
      <path
        d="M8.04096 14.7832L9.33588 18.7688H13.5269L10.1364 21.2323L11.4314 25.218L8.04096 22.7547L4.65041 25.218L5.94557 21.2323L2.55518 18.7688H6.74596L8.04096 14.7832Z"
        fill="#D80027"
      />
      <path
        d="M11.6029 20.3253L8.22807 19.1296C8.22807 19.1296 7.97869 16.7904 7.96361 16.7111C7.84908 16.1077 7.31885 15.6514 6.68213 15.6514C5.96182 15.6514 5.37775 16.2354 5.37775 16.9557C5.37775 17.0752 5.39518 17.1903 5.42525 17.3003L4.479 18.2529H6.1615C6.1615 19.9992 4.85838 19.9992 4.85838 21.7383L5.58127 23.4775H9.92908L10.6538 21.7383H10.6535C10.726 21.5714 10.7701 21.3993 10.7883 21.2274C11.413 20.9747 11.6029 20.3253 11.6029 20.3253Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112816">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default ZimbabweSvg;
